import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoute from 'components/PrivateRoute';

import Landing from 'views/Landing';
import Financials from 'views/Financials';
import DSPs from 'views/DSPs';
import Releases from 'views/Releases';
import ReportInvoices from 'views/ReportInvoices';
import TrackRevenues from 'views/TrackRevenues/track-revenues';
import TrackSplits from 'views/TrackSplits';
import Payees from 'views/Payees/payees';
import DistributionHistory from 'views/DistributionHistory';
import RoyaltyTransfers from 'views/RoyaltyTransfers';
import AffiliatePayments from 'views/AffiliatePayments';
import PlatformFees from 'views/PlatformFees';
import Settings from 'views/Settings';
import Groups from 'views/Groups/list-groups';
import ListRecoupAccounts from 'views/RecoupAccount/ListRecoupAccounts';
import CreateRecoupAccount from 'views/RecoupAccount/CreateRecoupAccount';
import EditRecoupAccount from 'views/RecoupAccount/EditRecoupAccount';
import RecoupAccount from 'views/RecoupAccount/ViewRecoupAccount';
import ListReportFiles from 'views/ReportFiles/ListReportFiles';
import Artists from 'views/Artists';
import ServiceDeals from 'views/ServiceDeals';
import CreateEditServiceDeal from 'views/ServiceDeals/create-edit-service-deal';
import MembershipPerks from 'views/MembershipPerks/membership-perks';
import CreateMembershipPerk from 'views/MembershipPerks/membership-perk-create';
import EditMembershipPerk from 'views/MembershipPerks/membership-perk-edit';
import MembershipEvents from 'views/MembershipEvents/membership-events';
import EditMembershipEvent from 'views/MembershipEvents/membership-event-edit';
import CoManagerDocuments from 'views/CoManagerDocuments';
import CreateEditCoManagerDocument from 'views/CoManagerDocuments/create-edit-comanager-document';
import UniversalLookupByEmail from 'views/UniversalLookupByEmail';
import LinkfireIngestionHistory from 'views/LinkfireIngestionHistory';
import QueryLibrary from 'views/QueryLibrary';

export const APP_VIEWS = {
  LANDING: 'LANDING',
  DSPS: 'DSPS',
  MANAGE_RELEASES: 'MANAGE_RELEASES',
  ARTISTS: 'ARTISTS',
  DISTRIBUTION_HISTORY: 'DISTRIBUTION_HISTORY',
  TRACK_SPLITS: 'TRACK_SPLITS',
  PAYEES: 'PAYEES',
  FINANCIALS: 'FINANCIALS',
  REPORT_INVOICES: 'REPORT_INVOICES',
  TRACK_REVENUES: 'TRACK_REVENUES',
  PAYMENT_ACCOUNTS: 'PAYMENT_ACCOUNTS',
  PLATFORM_FEES: 'PLATFORM_FEES',
  SETTINGS: 'SETTINGS',
  GROUPS: 'GROUPS',
  RECOUP_ACCOUNTS: 'RECOUP_ACCOUNTS',
  CREATE_RECOUP_ACCOUNT: 'CREATE_RECOUP_ACCOUNT',
  EDIT_RECOUP_ACCOUNT: 'EDIT_RECOUP_ACCOUNT',
  REPORT_FILES: 'REPORT_FILES',
  SERVICE_DEALS: 'SERVICE_DEALS',
  COMANAGER_DOCUMENTS: 'COMANAGER_DOCUMENTS',
  LINKFIRE_INGESTION_HISTORY: 'LINKFIRE_INGESTION_HISTORY',
  QUERY_LIBRARY: 'QUERY_LIBRARY',
};

const Routes = ({ isPrivate }) => {
  const RouteComponent = isPrivate ? PrivateRoute : Route;

  return (
    <Switch>
      <RouteComponent path="/" exact render={props => <Landing name={APP_VIEWS.LANDING} {...props} />} />
      <RouteComponent path="/settings" render={props => <Settings name={APP_VIEWS.SETTINGS} {...props} />} />
      <RouteComponent
        path="/track-splits"
        exact
        render={props => <TrackSplits name={APP_VIEWS.TRACK_SPLITS} {...props} />}
      />
      <RouteComponent path="/payees" exact render={props => <Payees name={APP_VIEWS.PAYEES} {...props} />} />
      <RouteComponent path="/dsps" exact render={props => <DSPs name={APP_VIEWS.DSPS} {...props} />} />
      <RouteComponent
        path="/manage-releases"
        exact
        render={props => <Releases name={APP_VIEWS.MANAGE_RELEASES} {...props} />}
      />
      <RouteComponent path="/artists" exact render={props => <Artists name={APP_VIEWS.ARTISTS} {...props} />} />
      <RouteComponent
        path="/manage-releases/payment-account/:paymentAccountId"
        exact
        render={props => <Releases name={APP_VIEWS.MANAGE_RELEASES} {...props} />}
      />
      <RouteComponent
        path="/distribution-history"
        exact
        render={props => <DistributionHistory name={APP_VIEWS.DISTRIBUTION_HISTORY} {...props} />}
      />
      <RouteComponent
        path="/financials"
        exact
        render={props => <Financials name={APP_VIEWS.FINANCIALS} {...props} />}
      />
      <RouteComponent
        path="/report-invoices"
        exact
        render={props => <ReportInvoices name={APP_VIEWS.REPORT_INVOICES} {...props} />}
      />
      <RouteComponent
        path="/track-revenues"
        exact
        render={props => <TrackRevenues name={APP_VIEWS.TRACK_REVENUES} {...props} />}
      />
      <RouteComponent
        path="/royalty-transfers"
        exact
        render={props => <RoyaltyTransfers name={APP_VIEWS.PAYMENT_ACCOUNTS} {...props} />}
      />
      <RouteComponent
        path="/affiliate-payments"
        exact
        render={props => <AffiliatePayments name={APP_VIEWS.PAYMENT_ACCOUNTS} {...props} />}
      />
      <RouteComponent
        path="/recoupment-account/create"
        exact
        render={props => <CreateRecoupAccount name={APP_VIEWS.CREATE_RECOUP_ACCOUNT} {...props} />}
      />
      <RouteComponent
        path="/recoupment-account/edit/:id"
        exact
        render={props => <EditRecoupAccount name={APP_VIEWS.EDIT_RECOUP_ACCOUNT} {...props} />}
      />
      <RouteComponent
        path="/recoupment-accounts"
        exact
        render={props => <ListRecoupAccounts name={APP_VIEWS.RECOUP_ACCOUNTS} {...props} />}
      />
      <RouteComponent
        path="/recoupment-account/:id"
        exact
        render={props => <RecoupAccount name={APP_VIEWS.RECOUPMENT_ACCOUNTS} {...props} />}
      />
      <RouteComponent path="/recoupment-account/" exact render={() => <Redirect to="/recoupment-accounts" />} />
      <RouteComponent
        path="/platform-fees/:parentEntity"
        exact
        render={props => <PlatformFees name={APP_VIEWS.PLATFORM_FEES} {...props} />}
      />
      <RouteComponent
        path="/report-files"
        exact
        render={props => <ListReportFiles name={APP_VIEWS.REPORT_FILES} {...props} />}
      />

      <RouteComponent
        path="/service-deals"
        exact
        render={props => <ServiceDeals name={APP_VIEWS.SERVICE_DEALS} {...props} />}
      />
      <RouteComponent
        path="/service-deals/create"
        exact
        render={props => <CreateEditServiceDeal {...props} title="Create Service Deal" />}
      />
      <RouteComponent
        path="/service-deals/edit/:id"
        exact
        render={props => <CreateEditServiceDeal {...props} title="Edit Service Deal" />}
      />

      <RouteComponent
        path="/membership-perks"
        exact
        render={props => <MembershipPerks name={APP_VIEWS.SERVICE_DEALS} {...props} />}
      />
      <RouteComponent path="/membership-perks/create" exact render={props => <CreateMembershipPerk {...props} />} />
      <RouteComponent path="/membership-perks/edit/:id" exact render={props => <EditMembershipPerk {...props} />} />

      <RouteComponent
        path="/comanager-documents"
        exact
        render={props => <CoManagerDocuments name={APP_VIEWS.COMANAGER_DOCUMENTS} {...props} />}
      />
      <RouteComponent
        path="/comanager-documents/create"
        exact
        render={props => <CreateEditCoManagerDocument {...props} />}
      />
      <RouteComponent
        path="/comanager-documents/edit/:id"
        exact
        render={props => <CreateEditCoManagerDocument {...props} />}
      />

      <RouteComponent path="/membership-events" exact render={props => <MembershipEvents {...props} />} />
      <RouteComponent path="/membership-events/edit/:id" exact render={props => <EditMembershipEvent {...props} />} />

      <RouteComponent path="/groups" exact render={props => <Groups name={APP_VIEWS.GROUPS} {...props} />} />
      <RouteComponent path="/groups/:id" exact render={props => <Groups name={APP_VIEWS.GROUPS} {...props} />} />
      <RouteComponent path="/universal-lookup-by-email" exact render={props => <UniversalLookupByEmail {...props} />} />

      <RouteComponent
        path="/linkfire-ingestion-history"
        exact
        render={props => <LinkfireIngestionHistory name={APP_VIEWS.LINKFIRE_INGESTION_HISTORY} {...props} />}
      />
      <RouteComponent
        path="/query-library"
        exact
        render={props => <QueryLibrary name={APP_VIEWS.QUERY_LIBRARY} {...props} />}
      />
      <Redirect to="/" />
    </Switch>
  );
};

Routes.defaultProps = {
  isPrivate: false,
};

export default Routes;
